import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=0256d7ba&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=ts&"
export * from "./Cell.vue?vue&type=script&lang=ts&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=0256d7ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0256d7ba",
  null
  
)

export default component.exports